import FavoriteStar from './FavoriteStar';
import React,{useState} from 'react';
import {FILTERS,FILTER_IDS} from './FaceFiltersRegistry';
export default function AchievementFilters({value,onChange,renderPreview,query=''}){
 const [hint,setHint]=useState('');
 const items=[{reward:'artist',name:'Artist · אמן',symbol:'★'},{reward:'ceo',name:'CEO · מנכ״ל',symbol:'♥'}].filter(item=>`${item.name} ${item.reward}`.toLowerCase().includes(query.trim().toLowerCase()));
 if(!items.length)return null;
 return <section className="achievement-filters"><h4>הישגים</h4><div className="background-grid">{items.map(item=>{
  const id=FILTER_IDS.find(id=>FILTERS[id]?.reward===item.reward);
  return <div className="face-filter-card" key={item.reward}><button type="button" aria-pressed={!!id&&value===id} onClick={()=>id?onChange(id):setHint(`השלימו בסדנה את אתגר ${item.name}: מדבקת ${item.symbol}, ציור ושני צבעים.`)}>
   {renderPreview(item.reward)}<strong>{item.name}</strong><small>{id?'✓ נפתח לשימוש':'🔒 נעול · הישג בסדנה'}</small>
  </button><FavoriteStar id={id} name={item.name} locked={!id}/></div>;
 })}</div>{hint&&<p role="status">{hint} <button type="button" onClick={()=>setHint('')}>סגירה</button></p>}</section>;
}
